
import {Component, Vue} from "vue-property-decorator";
import EImzaServisIndir from "@/components/infos/EImzaServisIndir.vue";

@Component({
  components:{EImzaServisIndir}
})
export default class UyapBagliDegilView extends Vue{

}
